import React, { Component } from "react";
import axios from "axios";
import * as appConst from "../Common/constants";
import logo from "../Images/Center.jpeg";

class ReportHeaderMal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      desc: "",
      location: "",
      regno: "",
      address: "",
      phone: "",
      closeClass: ""
    };
  }

  componentDidMount() {
    if (this.props.IsClose === "1")
      this.setState({ closeClass: "btn btn-default btn-md mr-2" });
    else this.setState({ closeClass: "collapse" });

    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) + "/center/edit"
      )
      .then(response => {
        this.setState({
          name: response.data.nameMal,
          desc: response.data.descMal,
          location: response.data.locationMal,
          regno: response.data.regno,
          address: response.data.addressMal,
          phone: response.data.phone
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  render() {
    return (
      <div className="container-fluid">
        <div className="row p-1 ">
          <div className="col col-md-12" align="right">
            <button
              className={this.state.closeClass}
              onClick={this.onCloseClick}
            >
              X
            </button>
          </div>
        </div>

        <div className="row ">
          <div
            className="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 "
            align="right"
          >
            <h5> Generated by PalCare Plus</h5>
          </div>
          <div className="col-2 col-xs-2 col-sm-2 col-md-2 col-lg-2 ">
            <img src={logo} width="180px" height="180px" />
          </div>
          <div className="col-10 col-xs-10 col-sm-10 col-md-10 col-lg-10 ">
            <div className="row ">
              <div className="col col-md-10 ">
                <h1 align="center">{this.state.name}</h1>
              </div>
            </div>
            <div className="row ">
              <div className="col col-md-10 ">
                <h4 align="center">{this.state.desc}</h4>
              </div>
            </div>
            <div className="row ">
              <div className="col col-md-10 ">
                <h5 align="center">
                  Reg. {this.state.regno}, {this.state.address},{" "}
                  {this.state.location}, Phone : {this.state.phone}
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  onCloseClick = e => {
    this.props.onCloseClick();
  };
}

export default ReportHeaderMal;
